import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../modules/material.module';
import { PdfModalComponent } from './pdf-modal.component';
import { PdfModalService } from './pdf-modal.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    FlexLayoutModule,
    ReactiveFormsModule,
    MaterialModule,
    PdfViewerModule,
    CommonModule,
    BrowserModule
  ],
  exports: [PdfModalComponent],
  declarations: [PdfModalComponent],
  providers: [PdfModalService],
  entryComponents: [PdfModalComponent]
})
export class PdfModalModule { }



// WEBPACK FOOTER //
// ./src/app/core/pdf-modal/pdf-modal.module.ts